import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=54a7be76&scoped=true"
import script from "./LocalePicker.vue?vue&type=script&lang=ts"
export * from "./LocalePicker.vue?vue&type=script&lang=ts"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=54a7be76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7be76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
